import { useState } from "react";
import { Button, CustomDragger, ModalTooltip } from "../../../components";
import { useDispatch, useSelector, } from "react-redux";
import { createGroup, createManyStudens, getAllGroups } from "../../../redux/VRL/thunks";
import { message } from "antd";
import { onEditGroup } from "../../../api";

export const AddGroupV2 = ({ close, grupToEdit, editing, }) => {
    const [nameProyect, setnameProyect] = useState(editing ? grupToEdit.name : "")
    const [enableSaveButton, setenableSaveButton] = useState(true)
    const [arrayFile, setArrayFile] = useState([]);
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    const dispatch = useDispatch()

    const updateDataGroups = () => {
        dispatch(getAllGroups(proyectSelected._id))
    }

    const checkInputButton = (inputString) => {
        setnameProyect(inputString)
        inputString.length > 1 ?
            setenableSaveButton(false)
            : setenableSaveButton(true)
    }

    const sendNeProject = async () => {
        if (editing) {
            const response = await onEditGroup({
                name: nameProyect.trim(),
                groupId: grupToEdit._id
            })
            if (response) {
                message.success("Grupo editado")
                if (arrayFile.length > 0) {
                    onSubmit(grupToEdit._id)
                }
                updateDataGroups()
            }
            else {
                message.error("Algo salio mal")
            }
        }
        else {
            const response = await dispatch(createGroup({
                name: nameProyect.trim(),
                projectId: proyectSelected._id
            }))
            if (response) {
                console.log(response)
                message.success("Grupo creado")
                if (arrayFile.length > 0) {
                    onSubmit(response._id)
                }
                updateDataGroups()
            }
            else {
                message.error("Algo salio mal")
            }
        }
    }

    const onSubmit = async (grupId) => {
        const students = arrayFile.map((student) => {
            if (student[0]) {
                return {
                    userId: student[0].trim(),
                    name: student[1].trim(),
                };
            }
            else {
                return {}
            }
        });
        const response = await dispatch(createManyStudens({ students, learningGroupId: grupId }));
        if (response.status === 0) {
            message.success("Los alumnos se han creado con exito");
            close();
        } else {
            message.error("Error en la creacion de los alumnos: " + response.payload[0].msg);
        }
    };

    return (
        <div className="w-full h-full  flex items-center flex-col">
            <div className="w-full px-4">
                <div className="mt-8">
                    <span className="mt-4 mb-4 text-base font-medium text-686868">Nombre de grupo </span>
                    <span className="text-red-700" >*</span>
                    <input
                        value={nameProyect}
                        onChange={(e) => checkInputButton(e.target.value)}
                        placeholder="Ingresa el nombre del grupo" className="mt-4 w-full focus:outline-none border-b border-[#bcb9b9] mb-3" />
                </div>
                {/*  */}
                <div className="flex items-center mt-4 mb-2">
                    <p className="text-base font-medium text-686868 mr-2">Archivo</p>
                    <ModalTooltip
                        title={
                            "El archivo debe de ser un documento .csv que incluya solo dos columnas: matrículas en la primera y nombre completo en la segunda. No se debe incluir ninguna cabecera en el archivo."
                        }
                        placement={"right"}
                        color={"#3366FF"}
                    />
                </div>
                <div className="pb-6">

                    <CustomDragger
                        callback={(array) => {
                            setArrayFile(array);
                        }}
                    // disabled={values.FormType === "0"}
                    />
                </div>

                {/*  */}
            </div>
            <div className="absolute  bottom-0 h-[48px] pb-8 w-full flex justify-end items-center px-4">
                <Button
                    text="Cancelar"
                    isPrincipal={false}
                    onClick={() => {
                        close();
                    }}
                />
                <div className="w-4"></div>
                <Button
                    disabled={enableSaveButton}
                    text="Guardar"
                    isPrincipal={true}
                    onClick={() => {
                        sendNeProject()
                        close();
                    }}
                />
            </div>
        </div>
    );
};
